import React, {Component} from 'react';
import {connect} from "react-redux";
import {clickedNodeAction} from '../../../actions/clickedNodeActions';
import ValueTypeSelector from "./ValueTypeSelector";
import SelectBox from "./SelectBox";

class ToggleableValueTypeSelector extends Component {
    constructor(props) {
        super(props);
        this.onTypeSelect = this.onTypeSelect.bind(this);
    }

    onTypeSelect(text) {
        const xmlType = this.props.types.find((type) => type.text === text).xmlType;
        this.props.handleChange(this.props.selectedOption, xmlType);
        if (xmlType === "contextProperty") {
            if (this.props.contextProperties.length > 0) {
                this.props.handleChange(this.props.selectedValue, this.props.contextProperties[0].name);
            } else {
                this.props.handleChange(this.props.selectedValue, "");
            }
        } else if (xmlType === "constantValue") {
            this.props.handleChange(this.props.selectedValue, this.props.defaultInputValue);
        }
    }

    render() {
        const displayComponents = () => {
            return (
                <React.Fragment>
                    <div className="predicate-box left">
                        <ValueTypeSelector
                            types={this.props.types}
                            disableArea={this.props.disableArea}
                            selectedType={this.props.selectedType}
                            onTypeSelect={(text) => this.onTypeSelect(text)}
                        />

                        {this.props.selectedType === "contextProperty" && (
                            <select
                                value={this.props.value}
                                onChange={(event) => this.props.handleChange(this.props.selectedValue, event.target.value)}>
                                <option
                                    className="select-placeholder"
                                    value=""
                                    disabled
                                    defaultValue
                                >Please select an option
                                </option>
                                {this.props.contextProperties && this.props.contextProperties.map((contextProp) => (
                                    <option key={contextProp.name}>{contextProp.name}</option>
                                ))}
                            </select>
                        )}

                        {this.props.selectedType === "constantValue" && (
                            <input
                                type="text"
                                value={this.props.value}
                                onChange={(event) => this.props.handleChange(this.props.selectedValue, event.target.value)}
                            />
                        )}
                    </div>
                </React.Fragment>
            )
        };

        return (
            <React.Fragment>
                <div className="filter-group toggleable-selector">
                    <div className="filter-group-header">
                        <label className="checkbox-wrapper">
                            <input type="checkbox" className="checkbox" checked={this.props.isSelectorSelected}
                                   onChange={() => this.props.handleChange(this.props.selectorProperty, !this.props.isSelectorSelected)}/>
                            {this.props.label}
                        </label>
                    </div>
                </div>
                {this.props.isSelectorSelected && (
                    <div className="predicate-panel">
                        <div className="predicate-group no-border-left">
                            <div className="predicate-item">
                                <div className="predicate-item-content">
                                    {displayComponents()}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        contextProperties: state.contextProperties
    }
}

export default connect(mapStateToProps, {clickedNodeAction})(ToggleableValueTypeSelector);

